import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import authApi from "../../api/authApi";
import { getLabel } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import { getAuth } from "../../slices/authSlice";
import Global from "../../Global/Global";

const AuthRedirect = (props) =>
{

  //Location
  const Location = useLocation();
  const Navigate = useNavigate();

  //Redux
  const Dispatch = useDispatch();
  const auth = useSelector(getAuth);
  


  //State
  const [process, setProcess] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variables
  const component = "AuthRedirect";


  //Effect
  useEffect(() =>
  {

    async function redirectAuthGoogle(){

      const searchParams = new URLSearchParams(Location.search);

      let params = {};

      // Loop through all query parameters and insert in params
      searchParams.forEach((value, name) =>
      {
        params[name] = value;
      });


      if (Location.pathname == "/auth/redirect/google")
      {

        try{


          const response = await authApi.redirectAuthGoogle(params);

          if (response.Data && response.Data.User){

            localStorage.setItem(Global.apiToken, response.Data.token || "");
            localStorage.setItem(Global.apiTokenAI, response.Data.tokenAI || "");
            Navigate("/auth");


            //authApi.setRequestHeader();

          }else{
            throw new Error();
          }


          setProcess(false);

        }catch(err){

          setAlert({
            Title: getLabel("App", "Error"),
            Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
            Confirm: getLabel("App", "Ok"),
            onConfirm: () => Navigate("/"),
            Display: true
          });
        }





      } else if (Location.pathname == "/auth/redirect/azure"){

        try
        {


          const response = await authApi.redirectAuthAzure(params);

          if (response.Data && response.Data.User)
          {

            //Dispatch(setAuth(response.Data.User));
            localStorage.setItem(Global.apiToken, response.Data.token || "");
            localStorage.setItem(Global.apiTokenAI, response.Data.tokenAI || "");
            Navigate("/auth");
            //setLanguage(response.Data.User.languageCode, "");


            //authApi.setRequestHeader();

          } else
          {
            throw new Error();
          }


          setProcess(false);

        } catch (err)
        {

          setAlert({
            Title: getLabel("App", "Error"),
            Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
            Confirm: getLabel("App", "Ok"),
            onConfirm: () => Navigate("/"),
            Display: true
          });
        }

      }

    }

    redirectAuthGoogle();


  }, [Location, Dispatch, Navigate]);


  //Where do we go next if authentificaiton was a success.
  useEffect(() => {


    if (process) return;

    if (auth.isAuth){

      Navigate("/");

    }else if (auth.User){

      if (!auth.User.valide){
        Navigate("/auth/fill");
      }

    }

  }, [auth, process, Navigate]);


  return (
    <div className="auth_page_cont">
      <div className="auth_redirect_cont">
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_loading">
          {getLabel(component, "Preparing account")}<span>.</span><span>.</span><span>.</span>
        </div>
      </div>
    </div>
  );
}

export default AuthRedirect;